// extracted by mini-css-extract-plugin
export default {"policyTiles":"PolicyTiles_policyTiles__EwdHt","tile":"PolicyTiles_tile__AfOYP","popover":"PolicyTiles_popover__5JYpQ","card":"PolicyTiles_card__9e-Nm"};